/**
 * Estado visual del dashboard de tracking en el mapa.
 */
export enum TipoEstadoVistaDashboardEnum {
  /**
   * El corte sigue en curso.
   */
  EN_CURSO = 'en-curso',
  /**
   * El corte ya está normalizado.
   */
  NORMALIZADO = 'normalizado',
}
